"use client";

import type { useChat } from "@ai-sdk/react";
import { Trans } from "@lingui/react/macro";
import { getToolName, isToolUIPart, type ToolUIPart } from "ai";
import type { AgentUIMessage } from "@/lib/ai/types";
import { ApproveButton } from "../ui/approve-button";
import { DenyButton } from "../ui/deny-button";

type CreateDashboardInput = {
  organizationId: string;
  name: string;
};

type Props = {
  part: ToolUIPart;
  addToolResult: ReturnType<typeof useChat<AgentUIMessage>>["addToolResult"];
  sendMessage: ReturnType<typeof useChat<AgentUIMessage>>["sendMessage"];
};

export function CreateDashboardConfirm({
  part,
  addToolResult,
  sendMessage,
}: Props) {
  const isTarget =
    isToolUIPart(part) && getToolName(part) === "create_dashboard";
  if (!isTarget || part.state !== "input-available") return null;

  const input = (part.input ?? {}) as Partial<CreateDashboardInput>;
  const displayName = input.name && input.name.length > 0 ? input.name : "-";

  return (
    <div className="p-4 text-sm">
      <div className="mb-2 font-medium">
        <Trans>Do you want to create this dashboard?</Trans>
      </div>
      <ul className="mb-4 list-disc space-y-1 pl-5">
        <li>
          <Trans>Name: </Trans>
          <span className="font-medium">{displayName}</span>
        </li>
      </ul>
      <div className="flex gap-2">
        <ApproveButton
          toolCallId={part.toolCallId}
          toolName={getToolName(part)}
          addToolResult={addToolResult}
          sendMessage={sendMessage}
        >
          <Trans>Create</Trans>
        </ApproveButton>
        <DenyButton
          toolCallId={part.toolCallId}
          toolName={getToolName(part)}
          addToolResult={addToolResult}
          sendMessage={sendMessage}
        >
          <Trans>Cancel</Trans>
        </DenyButton>
      </div>
    </div>
  );
}
